import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted } from "vue";
import { JobSchema, JobTableProps } from "@/types";
import { jobColumns } from "@/util";
import { appStore, jobApiStore, jobStore } from "@/hooks";
import { DataTable, PanelCard } from "@/components/common";
import JobRow from "./JobRow.vue";


/**
 * Displays a table of project job uploads.
 */
const __default__ = {
  name: "JobsTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    displayProjectJobs: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const rows = computed(() =>
  props.displayProjectJobs ? jobStore.projectJobs : jobStore.jobs
);
const loading = computed(() => appStore.isLoading > 0);
const expanded = computed(() =>
  jobStore.selectedJob ? [jobStore.selectedJob.id] : []
);

onMounted(() => jobApiStore.handleReload());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        columns: _unref(jobColumns),
        expanded: expanded.value,
        loading: loading.value,
        rows: rows.value,
        "rows-per-page": 10,
        "data-cy": "job-table",
        "row-key": "id"
      }, {
        body: _withCtx((quasarProps) => [
          _createVNode(JobRow, {
            expanded: quasarProps.expand,
            "onUpdate:expanded": ($event: any) => ((quasarProps.expand) = $event),
            job: quasarProps.row,
            "quasar-props": quasarProps,
            onViewLogs: _unref(jobApiStore).handleViewLogs
          }, null, 8, ["expanded", "onUpdate:expanded", "job", "quasar-props", "onViewLogs"])
        ]),
        _: 1
      }, 8, ["columns", "expanded", "loading", "rows"])
    ]),
    _: 1
  }))
}
}

})